import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'

// import AmplifyVue from '@aws-amplify/ui-vue'
// import { Amplify } from 'aws-amplify'
// import * as AmplifyModules from "aws-amplify";
// import { AmplifyPlugin } from "aws-amplify-vue";
// import '@aws-amplify/ui-vue';

import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader'

import { Amplify } from 'aws-amplify'
// import awsconfig from './aws-exports'

// Amplify.configure(awsconfig)
// Pool Orgininal SMS
// Amplify.configure({
//   Auth: {
//     identityPoolRegion: 'us-east-1',
//     userPoolId: 'us-east-1_DxfDdoAw5',
//     userPoolWebClientId: '1rumfqh60gaeguejs55vfjjbht',
//   }
// })

Amplify.configure({
  Auth: {
    identityPoolRegion: 'us-east-1',
    userPoolId: 'us-east-1_hJttZzXS1',
    userPoolWebClientId: '4ns1lqcig72kd1ripvj3f253p7',
  },
})

applyPolyfills().then(() => {
  defineCustomElements(window)
})

Vue.config.ignoredElements = [/amplify-\w*/]
// Pool Orgininal SMS
// Amplify.configure({
//   Auth: {
//     identityPoolRegion: 'us-east-1',
//     userPoolId: 'us-east-1_DxfDdoAw5',
//     userPoolWebClientId: '1rumfqh60gaeguejs55vfjjbht',
//   }
// })

// // Pool Nuevo TOTP
// Amplify.configure({
//   Auth: {
//     identityPoolRegion: 'us-east-1',
//     userPoolId: 'us-east-1_MSSgXtsYV',
//     userPoolWebClientId: '5nitnpurvi0totggn1vtf1k98n',
//   }
// })

Vue.use(VueFeather)
Vue.use(flatPickr)
Vue.use(VueRouter)
Vue.use(vco)
// Vue.use(AmplifyPlugin, AmplifyModules);

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.component('apexchart', VueApexCharts)

// Uncomment this if you are having api served through other url or do not want to use fake backend
Vue.prototype.$http = require('axios')
// Vue.prototype.$http.defaults.baseURL  = 'http://localhost:5000/'

// Vue.prototype.$http.defaults.baseURL  = 'http://mock-api.coderthemes.com/'

// π

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
